export const getTitle = (title: string | string[] | undefined = []) => {
  const titles = typeof title === "string" ? [title].filter(Boolean) : title;

  if (titles.length === 0) return null;

  return [...titles, "Dinii Monitoring"].join(" - ");
};
